var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home--inner"},[_vm._v("\n  Home page\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }